import * as Yup from 'yup'

const userCountsReportSchema = Yup.object().shape({
  userId: Yup.string().required('User is required'),
})

export default userCountsReportSchema
